goog.provide("shadow.js.shim.module$src$svg$wpp$files$spreadsheet_svg$default");
shadow.js.shim.module$src$svg$wpp$files$spreadsheet_svg$default = shadow.js.shim.module$src$svg$wpp$files$spreadsheet_svg.default;
